import { Reveal } from "./Reveal";
import { DarkButton } from "./Buttons";

export const ClosingCTA = ({ onBuild }) => (
  <section id="closing" data-testid="closing-cta-section" className="scroll-mt-24 pb-24 pt-8 sm:pb-28" tabIndex={-1}>
    <div className="mx-auto w-full max-w-shell px-5 sm:px-8">
      <Reveal>
        <div className="flex flex-col items-start justify-between gap-8 rounded-[2rem] bg-gradient-to-br from-[#c8b8f0] via-lilac to-[#a78fe0] p-9 sm:p-14 lg:flex-row lg:items-center">
          <div>
            <h2 className="max-w-md font-display text-3xl font-extrabold leading-[1.12] tracking-tight text-ink sm:text-4xl">
              Your peptide business, started.
            </h2>
            <p className="mt-3 text-base text-ink/65">
              Supply, white-label vials, brand, website, and fulfillment — let's build the whole thing, together.
            </p>
          </div>
          <DarkButton testId="closing-build-button" onClick={onBuild} className="shrink-0">
            Request a launch proposal
          </DarkButton>
        </div>
      </Reveal>
    </div>
  </section>
);
